import qs from 'qs'
export const getMagazinePage = (axios) => {
  const query = qs.stringify({
    populate: [
      'serp',
      'social_sharing',
      'popular_articles',
      'popular_articles.cover_image',
    ],
  })
  return axios.get(`/api/gym-magazin?${query}`)
}
